export default __webpack_public_path__ + "static/media/92@2x-8.bad894c4.png";